import React from 'react';
import { TopicStyles } from './mixins/mixins';
import { StyleInupt, StyleSlider, StyleToggle } from './components/common';

export const QuoteStyle = ({
	style,
	setStyle
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	return (
		<div className="grid grid-cols-2 lg:grid-cols-3 justify-items-center gap-4">
			<StyleSlider
				key={'quote_size-range'}
				id={'quote_size-range'}
				name={'Size'}
				initialValue={style.quoteStyle.size}
				minValue={'0'}
				maxValue={'80'}
				step={'5'}
				handleChange={({ value }: { value: any }) => {
					setStyle({
						...style,
						quoteStyle: { ...style.quoteStyle, ['size']: value }
					});
				}}
			/>

			<StyleToggle
				key={'useCustomQuote'}
				style={style}
				styleObj={'quoteStyle'}
				parentStyle={style.quoteStyle}
				styleKey={'useCustomQuote'}
				name={'Use Custom Quote'}
				optionState={style.quoteStyle.useCustomQuote}
				setStyle={setStyle}
			/>

			{style.quoteStyle.useCustomQuote && (
				<StyleInupt
					key={'custom_quote'}
					name={'Custom Quote'}
					placeholder="Custom quote"
					optionState={style.quoteStyle.customQuote}
					handleChange={(value: any) => {
						setStyle({
							...style,
							quoteStyle: { ...style.quoteStyle, ['customQuote']: value }
						});
					}}
				/>
			)}
		</div>
	);
};
